import { Injectable } from '@angular/core';
import { createStore, select, setProps, withProps } from '@ngneat/elf';
import { Country } from '../models/country.model';
import { County } from '../models/county.model';
import { Municipality } from '../models/municipality.model';
import { write } from './mutations';

export interface UtilitiesState {
  municipalities: Municipality[];
  counties: County[];
  countries: Country[];
}

const store = createStore(
  { name: 'utilities' },
  withProps<UtilitiesState>({
    municipalities: [],
    counties: [],
    countries: [],
  }),
);

@Injectable({ providedIn: 'root' })
export class UtilitiesRepository {
  municipalities$ = store.pipe(select((state) => state.municipalities));
  counties$ = store.pipe(select((state) => state.counties));

  getMunicipalities() {
    return store.query((state) => state.municipalities);
  }

  getCounties() {
    return store.query((state) => state.counties);
  }

  getCountries() {
    return store.query((state) => state.countries);
  }

  setMunicipalities(municipalities: Municipality[]) {
    store.update(
      setProps(write((state) => (state.municipalities = municipalities))),
    );
  }

  setCounties(counties: County[]) {
    store.update(setProps(write((state) => (state.counties = counties))));
  }

  setCountries(countries: Country[]) {
    store.update(setProps(write((state) => (state.countries = countries))));
  }
}
